import React from 'react';
import { Component } from 'reflux';
import { Panel } from 'widgets/default/panel';
import { Header } from 'widgets/default/Header';
import { PanelBody } from 'widgets/default/panel/body';
import { PanelFooter } from 'widgets/default/panel/footer';
import Table from '../table/Table';
import TableHeader from '../table/Header';
import TableBody from '../table/Body';
import TableRow from '../table/Row';
import TableColumn from '../table/Column';
import { actions } from 'actions';
import { SupplierDocumentStore } from 'stores/SupplierDocumentStore';
import { FileEntry } from './FileEntry';
import Uploader from './Uploader';
import { UploadButton } from './UploadButton';

class DocumentsWidget extends Component {
  state = {
    documents: [],
  }

  constructor(props) {
    super(props);

    this.mapStoreToState(SupplierDocumentStore, this.documentsChanged);
  }

  componentWillMount() {
    const { supplier: { uid: supplierId } } = this.props;

    actions.getDocuments(supplierId);
  }

  documentsChanged = ({ documents }) => {
    return { documents: documents };
  }

  uploadDone = () => {
    const { supplier : { uid: supplierId } } = this.props;

    actions.getDocuments(supplierId);
  }

  getNdaUploadButton() {
    if (this.state.documents.filter(({ type }) => [1, 3].includes(type)).length !== 0) {
        return false;
    }

    const { supplier: { uid: supplierId } } = this.props;
    
    return (
      <Uploader url={this.getUploadUrl(1)} uploadDone={this.uploadDone} supplierId={supplierId}>
        <UploadButton type="NDA" />
      </Uploader>
    );
  }

  getUploadUrl(type) {
    const { supplier : { uid: supplierId } } = this.props;

    return '/rest/v2/supplier/'+supplierId+'/document?type='+type;
  }

  render() {
    const { supplier : { uid: supplierId } } = this.props;

    return (
      <Panel>
        <Header title="Documents" />
        <PanelBody>
          <Table margin="0">
            <TableHeader>
              <TableRow>
                <TableColumn><strong>Type</strong></TableColumn>
                <TableColumn><strong>Time</strong></TableColumn>
                <TableColumn><strong>File</strong></TableColumn>
              </TableRow>
            </TableHeader>
            <TableBody>
              {this.state.documents.map((document) => (
                <FileEntry key={document.uid} {...document} />
              ))}
            </TableBody>
          </Table>
        </PanelBody>
        <PanelFooter>
          <div className="clearfix">
            <div className="pull-right">
              {this.getNdaUploadButton()}

              <Uploader url={this.getUploadUrl(2)} uploadDone={this.uploadDone} supplierId={supplierId}>
                <UploadButton type="Contract" />
              </Uploader>
              
              <Uploader url={this.getUploadUrl(7)} uploadDone={this.uploadDone} supplierId={supplierId}>
                <UploadButton type="Native Check" />
              </Uploader>

              <Uploader url={this.getUploadUrl(4)} uploadDone={this.uploadDone} supplierId={supplierId}>
                <UploadButton type="Broadcast Rate Card" />
              </Uploader>

              <Uploader url={this.getUploadUrl(5)} uploadDone={this.uploadDone} supplierId={supplierId}>
                <UploadButton type="Non-Broadcast Rate Card" />
              </Uploader>
            </div>
          </div>
        </PanelFooter>
      </Panel>
    );
  }
}

export { DocumentsWidget };
